<template>
    <div v-if="fetched">
        <data-grid-global
            v-if="fromGlobalRegion"
            :bill="bill"
            :requisites="requisites"
            :user-requisites="userRequisites"
            :nds-data="ndsData"
        />

        <data-grid-eu
            v-else-if="fromEuRegion"
            :bill="bill"
            :requisites="requisites"
            :user-requisites="userRequisites"
            :nds-data="ndsData"
        />

        <data-grid-md
            v-else-if="fromMdRegion"
            :bill="bill"
            :requisites="requisites"
            :user-requisites="userRequisites"
            :nds-data="ndsData"
        />

        <data-grid
            v-else
            :bill="bill"
            :requisites="requisites"
            :user-requisites="userRequisites"
            :nds-data="ndsData"
        />
    </div>
</template>

<script>
import { date } from 'quasar'

import api from 'mixins/api'
import DataGrid from './ua/DataGrid'
import DataGridGlobal from './global/DataGrid'
import DataGridEu from './eu/DataGrid.vue'
import DataGridMd from './md/DataGrid.vue'
import {COMPANY_TYPES_WITH_EDRPOU, COMPANY_TYPES_WITH_INN} from "../../constants/companyTypes";

export default {
    name: 'InvoiceView',

    components: {
        DataGrid,
        DataGridGlobal,
        DataGridEu,
        DataGridMd,
    },

    mixins: [
        api,
    ],

    data () {
        return {
            userRequisites: {
                company_name: '',
                company_type: 0,
                edrpou: '',
                inn: '',
                legal_address: '',
                actual_address: '',
                user_position: '',
                full_name: '',
                iban: '',
            },

            bill: {
                number: null,
                created_at: null,
                true_created_at: null,
                amount: null,
                actName: '',
                unit: '',
                destination: '',
                project: {
                    service_code: '',
                },
                user: {},
                provider: {},
            },

            requisites: {
                additional_info: '',
                address: '',
                bank_name: '',
                checking_account: '',
                mfi: '',
                name: '',
                sender: '',
                tin: '',
                stamp_img_url: '',
                name_in_signature: '',
            },

            ndsData: {
                'ndsPayer': 0,
            },

            months: [
                'січня',
                'лютого',
                'березня',
                'квітня',
                'травня',
                'червня',
                'липня',
                'серпня',
                'вересня',
                'жовтня',
                'листопада',
                'грудня',
            ],

          monthsMd: [
            'ianuarie',
            'februarie',
            'martie',
            'aprilie',
            'mai',
            'iunie',
            'iulie',
            'august',
            'septembrie',
            'octombrie',
            'noiembrie',
            'decembrie',
          ],

            monthsGlobal: [
                'January',
                'February',
                'March',
                'April',
                'May',
                'June',
                'July',
                'August',
                'September',
                'October',
                'November',
                'December',
            ],

            fetched: false,
        }
    },

    computed: {
        userId () {
            return this.$route.query.userId
        },

        fromGlobalRegion () {
            return this.bill.project.region === 'Global'
        },

        fromEuRegion () {
            return this.bill.project.region === 'EU'
        },

        fromMdRegion () {
          return this.bill.project.region === 'MD'
        },
    },

    mounted () {
        if (!this.$route.query) {
            return
        }

        if (this.$route.query.token) {
            this.fetchDataByToken()
            return
        }

        if (this.$route.query.userId && this.$auth.check()) {
            this.fetchBill()
            return
        }

        this.$router.push('/welcome')
    },

    methods: {
        fetchBill () {
            this.$http.get(`api/v1.0/users/${this.$route.query.userId}/bills/${this.$route.params.id}`).
                then(response => {
                    if (response.data) {
                        this.bill = response.data
                        this.user = this.bill.user
                        this.bill.true_created_at = this.bill.created_at
                        this.bill.created_at = this.fixDate(date.formatDate(this.bill.created_at, 'D M YYYY'))
                        this.userRequisites = this.getUserRequisites()
                        this.ndsData.ndsPayer = this.bill.provider.nds_payer
                        this.requisites = this.getInvoiceRequisites(this.bill.provider)
                        this.fetched = true
                    }
                }).
                catch(error => {
                    this.$router.push('/404')
                })
        },

        fetchDataByToken () {
            this.$http.get(`api/v1.0/bill-info/${this.$route.params.id}?token=${this.$route.query.token}`).
                then(response => {
                    if (response.data.error) {
                        this.$q.notify({ message: response.data.error })
                        return
                    }

                    if (response.data) {
                        this.bill = response.data.bill
                        this.user = this.bill.user
                        this.bill.true_created_at = this.bill.created_at
                        this.bill.created_at = this.fixDate(date.formatDate(this.bill.created_at, 'D M YYYY'))
                        this.userRequisites = this.getUserRequisites()
                        this.ndsData.ndsPayer = this.bill.provider.nds_payer
                        this.requisites = this.getInvoiceRequisites(this.bill.provider)
                        this.fetched = true
                    }
                }).
                catch(error => {
                    this.$router.push('/404')
                })
        },

        getInvoiceRequisites (serviceProvider) {
            const invoiceMethod = serviceProvider.payment_details.find(row => row.payment_method === 'invoice')

            if (!invoiceMethod) {
                return
            }

            return Object.assign({
                name: serviceProvider.name,
            }, invoiceMethod.requisites)
        },

        getUserRequisites () {
            const paymentData = this.bill.is_paid
                ? this.bill.payment_data
                : this.bill.project.payment_data

            const companyType = paymentData?.company_type;

            return {
                ...paymentData,
                inn: (companyType && COMPANY_TYPES_WITH_INN.includes(companyType)) ? paymentData.inn : '',
                edrpou: (companyType && COMPANY_TYPES_WITH_EDRPOU.includes(companyType)) ?paymentData.edrpou : '',
            }
        },

        fixDate (date) {
            let monthNumber = parseFloat(date.split(' ')[1]) - 1

            if (this.fromGlobalRegion || this.fromEuRegion) {
                return date.replace(/(\d+) (\d+) (\d+)/, this.monthsGlobal[monthNumber] + ' $1, $3')
            }

            const monthsArray = this.fromMdRegion ? this.monthsMd : this.months;

            return date.replace(/(\d+) (\d+) (\d+)/, '$1 ' + monthsArray[monthNumber] + ' $3')
        },
    },
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/views/Invoice/InvoiceView.vue